module.exports = __webpack_public_path__ + "static/media/youtubebannermobil.e872118a.png";